/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { XsoarAccountMappingDto } from './XsoarAccountMappingDto';
import {
    XsoarAccountMappingDtoFromJSON,
    XsoarAccountMappingDtoFromJSONTyped,
    XsoarAccountMappingDtoToJSON,
    XsoarAccountMappingDtoToJSONTyped,
} from './XsoarAccountMappingDto';

/**
 * 
 * @export
 * @interface XsoarAccountMappingListResponse
 */
export interface XsoarAccountMappingListResponse {
    /**
     * 
     * @type {Array<XsoarAccountMappingDto>}
     * @memberof XsoarAccountMappingListResponse
     */
    data?: Array<XsoarAccountMappingDto>;
    /**
     * 
     * @type {number}
     * @memberof XsoarAccountMappingListResponse
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof XsoarAccountMappingListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof XsoarAccountMappingListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof XsoarAccountMappingListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof XsoarAccountMappingListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the XsoarAccountMappingListResponse interface.
 */
export function instanceOfXsoarAccountMappingListResponse(value: object): value is XsoarAccountMappingListResponse {
    return true;
}

export function XsoarAccountMappingListResponseFromJSON(json: any): XsoarAccountMappingListResponse {
    return XsoarAccountMappingListResponseFromJSONTyped(json, false);
}

export function XsoarAccountMappingListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): XsoarAccountMappingListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(XsoarAccountMappingDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function XsoarAccountMappingListResponseToJSON(json: any): XsoarAccountMappingListResponse {
    return XsoarAccountMappingListResponseToJSONTyped(json, false);
}

export function XsoarAccountMappingListResponseToJSONTyped(value?: XsoarAccountMappingListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(XsoarAccountMappingDtoToJSON)),
        'total': value['total'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

